/**
 * LogPortionsModalWrapper - Functional wrapper for legacy LogPortionsModal
 * 
 * This component provides a functional React interface for the legacy LogPortionsModal,
 * integrating it with our modal management system while preserving all original functionality.
 */

import React from 'react';
import PropTypes from 'prop-types';
import LogPortionsModal from '../../../Planner/Modals/LogPortionsModal.react';

const LogPortionsModalWrapper = ({
    contents,
    profile,
    defaultPortions,
    requirePrecise,
    modalTitle,
    ctaText,
    onSelectPortions,
    closeModal
}) => {
    const handleSelectPortions = (contents, portions) => {
        // Call the provided callback with the selected portions
        onSelectPortions(contents, portions);
        // Close the modal
        closeModal();
    };

    return (
        <LogPortionsModal
            contents={contents}
            profile={profile}
            defaultPortions={defaultPortions}
            requirePrecise={requirePrecise}
            modalTitle={modalTitle}
            ctaText={ctaText}
            closeModal={closeModal}
            onSelectPortions={handleSelectPortions}
        />
    );
};

LogPortionsModalWrapper.propTypes = {
    contents: PropTypes.array.isRequired,
    profile: PropTypes.object,
    defaultPortions: PropTypes.array,
    requirePrecise: PropTypes.bool,
    modalTitle: PropTypes.node,
    ctaText: PropTypes.node,
    onSelectPortions: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired
};

LogPortionsModalWrapper.defaultProps = {
    requirePrecise: true,
    modalTitle: 'How much did you eat?'
};

export default LogPortionsModalWrapper;